import { maxBy } from 'lodash-es';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { decodedUserTokenSelector } from '@xarvio/frontend-core-state/lib/auth/selectors';
import { localeSelector } from '@xarvio/frontend-core-state/lib/intl/selectors';
import { selectedFarmUuidSelector } from '@xarvio/frontend-core-state/lib/selectedFarm/selectors';

import { getPageUrlDic, Page } from './routes';

interface GetCurrentPage {
  farmUuid: string;
  country: string;
  locale: string;
  pathName: string;
}

export const getCurrentPage = ({
  farmUuid,
  country,
  locale,
  pathName,
}: GetCurrentPage): Page => {
  const prefix = `/${country}/${locale}`;
  const pageDic = getPageUrlDic({ prefix, farmUuid });
  const pages = Object.keys(Page).filter(
    (page) => page !== Page.NOT_IMPLEMENTED_YET,
  ) as Page[];
  const matchedPages = pages.filter((key) =>
    pathName.startsWith(pageDic[Page[key]]),
  );

  return (
    maxBy(matchedPages, (key) => pageDic[key].length) ||
    Page.NOT_IMPLEMENTED_YET
  );
};

export const useGetCurrentPage = () => {
  const { country } = useSelector(decodedUserTokenSelector);
  const locale = useSelector(localeSelector);
  const location = useLocation();
  const currentFarmUuid = useSelector(selectedFarmUuidSelector);

  return getCurrentPage({
    farmUuid: currentFarmUuid,
    country,
    locale,
    pathName: location.pathname,
  });
};
